/** localStorage: user soft-dismissed the permission prompt (per user). Value = dismissal time in epoch ms. */
export const PWA_PUSH_PROMPT_DISMISSED_KEY_PREFIX = 'pwa.push.promptDismissed.';

/** Value the dismissed key held before the cooldown existed — meant "never ask again". */
export const PWA_PUSH_PROMPT_DISMISSED_LEGACY_VALUE = '1';

/** How long a soft dismissal is respected before the prompt may show again. */
export const PWA_PUSH_PROMPT_COOLDOWN_MS = 24 * 60 * 60 * 1000;

/** localStorage: subscription synced to API for this user. */
export const PWA_PUSH_SYNCED_KEY_PREFIX = 'pwa.push.synced.';
